export default "__VITE_ASSET__BcBki5IH__"